<app-layout-main
	[pageMetadata]="{
		title: pageTitle()
	}"
>
	<lib-message [title]="'404'" [type]="'warning'">This page does not exist.</lib-message>

	<div class="push-top">
		<lib-button [buttonType]="'primaryLight'" [routerLink]="goBackUrl()" [icon]="'arrowBack'">{{
			goBackText()
		}}</lib-button>
	</div>
</app-layout-main>
